import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Overviewbar from "./Overviewbar";
import "../cssfiles/homepage.css";
import { Box, Breadcrumbs, Typography } from "@mui/material";
import SearchConfig from "./CommonComponents/SearchConfig";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ReportingLeftPane from "./ReportingLeftPane";
import ReportingMainPage from "./ReportingMainPage";

export default function ReportingModule() {
  const selectedtreepath = useSelector(
    (state) => state.reportdata.reporttreepathselected
  );
  const tabpath = useSelector(
    (state) => state.reportdata.selectedreporttabpath
  );
  const overviewstate = useSelector(
    (state) => state.mainpagedata.overviewbarstate
  );
  const [pagesize, setPagesize] = useState(168);

  const [pathselected, setPathselected] = useState([
    <Typography
      key="Dashboards"
      className="crumbs-reporting"
      style={{ fontSize: "14px", fontWeight: 400 }}
    >
      General
    </Typography>,
  ]);

  useEffect(() => {
    if (overviewstate) {
      setPagesize(265);
    } else {
      setPagesize(235);
    }
  }, [overviewstate]);

  useEffect(() => {
    var newpath = [];
    for (let i = 0; i < selectedtreepath.length; i++) {
      newpath.push(
        <Typography
          key="Dashboards"
          className="crumbs-reporting"
          style={{ fontSize: "14px", fontWeight: 400 }}
        >
          {selectedtreepath[i]}
        </Typography>
      );
    }
    for (let i = 0; i < tabpath.length; i++) {
      newpath.push(
        <Typography
          key="Dashboards"
          className="crumbs"
          style={{ fontSize: "14px", fontWeight: 400 }}
        >
          {tabpath[i]}
        </Typography>
      );
    }
    setPathselected(newpath);
  }, [selectedtreepath, tabpath]);

  return (
    <Box className="reporting-module">
      <Overviewbar />
      <div
        style={{ display: "flex", flexDirection: "row", marginRight: "18px" }}
      >
        <div
          className="breadcrumb-reporting"
          style={{ flexGrow: 1, marginRight: "4px", marginLeft: "16px" }}
        >
          <Breadcrumbs
            separator={
              <NavigateNextIcon
                fontSize="small"
                sx={{ color: "var(--GreyVariation_2)" }}
              />
            }
            style={{ padding: "10px 12px 10px 12px", textAlign: "center" }}
          >
            {pathselected}
          </Breadcrumbs>
        </div>
        <SearchConfig />
      </div>

      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          height: `calc(100vh - ${pagesize}px)`,
          padding: "0px 16px",
          boxSizing: "border-box",
        }}
      >
        <ReportingLeftPane />
        <ReportingMainPage />
      </Box>
    </Box>
  );
}
